import { render, staticRenderFns } from "./phone-verification-modal.vue?vue&type=template&id=3af2fd54&scoped=true"
import script from "./phone-verification-modal.vue?vue&type=script&lang=js"
export * from "./phone-verification-modal.vue?vue&type=script&lang=js"
import style0 from "./phone-verification-modal.vue?vue&type=style&index=0&id=3af2fd54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2fd54",
  null
  
)

export default component.exports